
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.999 19.166a9.167 9.167 0 100-18.333 9.167 9.167 0 000 18.333zm1.25-13.333a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm0 2.5v6.666h-2.5V8.333h2.5z","fill":"#2C8DFF"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"20","height":"20"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.999 19.166a9.167 9.167 0 100-18.333 9.167 9.167 0 000 18.333zm1.25-13.333a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm0 2.5v6.666h-2.5V8.333h2.5z","fill":"#fff"}})])])
          )
        }
      }
    